import { PlusCircleIcon } from "@heroicons/react/24/outline";
import { Handle, Position } from "reactflow";

export function NewNode(props: {
  data: {
    id: string;
    newStep: () => void;
  };
}) {
  return (
    <div className="cursor-pointer text-gray-300 hover:text-gray-400">
      <Handle type="target" position={Position.Top} id={props.data.id} />
      <div className="h-6 w-6 rounded-full ">
        <PlusCircleIcon onClick={() => props.data.newStep()} />
      </div>
    </div>
  );
}
